import {createContext} from "react";
import {initialAdvertiserLoginObj} from "./AdvertiserLogin"
import {IAdvertiserLogins} from "../interfaces/IAdvertiserLogins";

export const AdvertiserLoginContext = createContext({
    advertiserLogin: initialAdvertiserLoginObj,
    setAdvertiserLogin: (advertiserLogin: IAdvertiserLogins) => {}
})
